import { render, staticRenderFns } from "./store-card.vue?vue&type=template&id=047f58bc&scoped=true"
import script from "./store-card.vue?vue&type=script&lang=js"
export * from "./store-card.vue?vue&type=script&lang=js"
import style0 from "./store-card.vue?vue&type=style&index=0&id=047f58bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047f58bc",
  null
  
)

export default component.exports